export default __webpack_public_path__ + "static/media/banner7-mobile.327873dc.jpg";